import React, { createContext, useContext, useEffect, useState } from 'react'
import PageLoader from '../../components/info/pageloader'
import Toast from '../../components/info/toast'

const GlobalContext = createContext()

export const GlobalProvider = ({ storeData, apiClient, children }) => {

  var [showLoader, setShowLoader] = useState(false)
  var [loaderText, setLoaderText] = useState('')

  var [showToast, setShowToast] = useState(false)
  var [toastText, setToastText] = useState('')

  const auth = storeData ? {
    store: storeData,
    user: storeData.users[storeData.index],
    users: storeData.users,
    index: storeData.index
  } : null

  const UAParser = require('ua-parser-js')
  const info = new UAParser().setUA(navigator.userAgent).getResult()

  const deviceInfo = {
    isMobileDevice: info.os.name == "Android" || info.os.name == "iOS",
    os: info.os.name,
    browser: info.browser.name,
    isChrome: info.browser.name == "Chrome",
    isDev: window.location.hostname == "localhost",
    appInstalled: !!window.matchMedia('(display-mode: standalone)').matches,
  }

  const api = apiClient

  const pageLoader = {
    show: text => {
      setLoaderText(text)
      setShowLoader(true)
    },
    hide: () => { setShowLoader(false) }
  }

  const toast = {
    show: text => {
      setToastText(text)
      setShowToast(true)
    },
    hide: () => {
      setShowToast(false)
      setToastText('')
    }
  }

  return (
    <GlobalContext.Provider value={{ auth, deviceInfo, api, pageLoader, toast }}>
      <>
        {showLoader && <PageLoader block text={loaderText} />}
        <Toast show={showToast} text={toastText} onHide={() => { setShowToast(false) }} />
        {children}
      </>
    </GlobalContext.Provider>
  )
}

export const useGlobal = () => {
  return useContext(GlobalContext)
}
